// extracted by mini-css-extract-plugin
module.exports = {"pulse":"styles_pulse__ndQEK","jump":"styles_jump__bmvFk"};